import { tenantHttp, type HttpClient, type QueryParams } from './core/http-client';
import type {
  Customer,
  CustomerInput,
  Location,
  Product,
  ProductInput,
  ProductPageMeta,
} from './models';

export class CatalogService {
  constructor(private readonly http: HttpClient) {}

  customers = (query: QueryParams) => this.http.getPage<Customer>('/business/customers', { query });

  saveCustomer = (b: CustomerInput) => this.http.post<Customer>('/business/customers', b);

  deleteCustomer = (id: string) => this.http.delete(`/business/customers/${id}`);

  products = (query: QueryParams) =>
    this.http.getList<Product, ProductPageMeta>('/business/products', { query });

  saveProduct = (b: ProductInput) => this.http.put<Product>('/business/products', b);

  archiveProduct = (id: string) => this.http.post(`/business/products/${id}/archive`);

  locations = () => this.http.get<Location[]>('/business/locations');

  saveLocation = (b: unknown) => this.http.put<Location>('/business/locations', b);

  archiveLocation = (id: string) => this.http.post(`/business/locations/${id}/archive`);
}

export const catalogService = new CatalogService(tenantHttp);
